<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name お問い合わせの種類
      span.validation-label 必須

    .register-value.support-radios
      label.register-radio-label
        input#type-0.register-radio-form(
          v-model="_value"
          name="message-type"
          type="radio"
          :value="0"
          v-validate="{ required: true }"
          data-vv-as="お問い合わせの種類")
        span.register-radio-text システムの不具合
      label.register-radio-label
        input#type-1.register-radio-form(v-model="_value" name="message-type" type="radio" :value="1")
        span.register-radio-text クレーム・ご意見
      label.register-radio-label
        input#type-2.register-radio-form(v-model="_value" name="message-type" type="radio" :value="2")
        span.register-radio-text 改善要望
      label.register-radio-label
        input#type-4.register-radio-form(v-model="_value" name="message-type" type="radio" :value="4")
        span.register-radio-text 操作方法
      label.register-radio-label
        input#type-5.register-radio-form(v-model="_value" name="message-type" type="radio" :value="5")
        span.register-radio-text その他ご質問

    .error-messages(v-for="error in errors.collect('message-type')")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { PlanType } from "@/commons/services/Plans";

/**
 * 入力要素コンポーネント
 *
 * - お問い合わせの種類の入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputSupportType extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Number })
  value!: number;

  @Prop({ required: true, type: Number })
  planType!: PlanType;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.support-radios {
  flex-wrap: wrap;
}
</style>
